import {
  type OnboardingAssigneeOptionsQuery,
  onboardingAssigneeOptionsResponseSchema,
} from '@gb-ticket/shared-types';
import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';
import { toSearchParams } from '@/lib/format';

export const onboardingAssigneeOptionsKey = (query: OnboardingAssigneeOptionsQuery) =>
  ['onboarding', 'assignee-options', query] as const;

/** Lookups + user page for onboarding assignee pickers (not platform.users:read). */
export function useOnboardingAssigneeOptions(
  query: OnboardingAssigneeOptionsQuery,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: onboardingAssigneeOptionsKey(query),
    queryFn: () =>
      apiFetch(
        `/onboarding/assignee-options${toSearchParams({
          page: query.page,
          pageSize: query.pageSize,
          q: query.q,
          includeInactive: query.includeInactive || undefined,
        })}`,
        onboardingAssigneeOptionsResponseSchema,
      ),
    enabled: options?.enabled ?? true,
  });
}
